import axios from 'axios'

export default {
    loadWidgetByPosition: function (position) {
        return axios.get('ru/api/public/cms/widget/' + position).then((response) => {
            if (response.status !== 200) {
                return Promise.reject(response);
            }
            return Promise.resolve(response);
        })
    },

    loadBlogBySlug: function (slug, limit = 0) {
        return axios.get('ru/api/public/cms/blog/' + slug + '/' + limit).then((response) => {
            if (response.status !== 200) {
                return Promise.reject(response);
            }
            return Promise.resolve(response);
        })
    },

    loadPageBySlug: function (slug) {
        return axios.get('ru/api/public/cms/article/' + slug).then((response) => {
            if (response.status !== 200) {
                return Promise.reject(response);
            }
            return Promise.resolve(response);
        })
    },

    getUserToken () {
        return axios.post('https://admin-ecoreport.at.kg/api/login_check', { username: 'admin@nd.kg', password: 'M70yr4bX' })
    },

    getGraph (token, unique) {
        return axios.get(`https://admin-ecoreport.at.kg/ru/api/graph/get?unique=${unique}`, {
            headers: {
              'Content-Type': 'application/json',
              "Authorization" : `Bearer ${token}`
            }})
    }
}
